var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Component } from 'react';
import { connect } from 'react-redux';
import { analytics } from 'app/utils/segment';
import { QueueSelect } from 'fable/queueSelect';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { notificationActions } from '../../../notifications/actions/notification';
import { transferToQueueActions } from '../actions/transferToQueueModal';
const mapStateToProps = (state) => {
    return state.transferToQueue;
};
const mapDispatchToProps = (dispatch) => {
    return {
        transferToQueueModalRequest: bindActionToPromise(dispatch, transferToQueueActions.transferToQueueModalRequest),
        modalOpen: (payload) => dispatch(transferToQueueActions.transferToQueueModalOpen(payload)),
        modalClose: () => dispatch(transferToQueueActions.transferToQueueModalClose()),
        notificationAdd: (payload) => dispatch(notificationActions.notificationAdd(payload)),
        transferToQueueModalRequestStop: (csid) => dispatch(transferToQueueActions.transferToQueueModalRequestStop({ csid })),
    };
};
class TransferToQueueModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedQueue: null,
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.ui.isModalShown === false &&
            prevProps.ui.isModalShown === true) {
            this.setState({
                selectedQueue: null,
            });
        }
    }
    onRequest() {
        const { selectedQueue: requestToQueue } = this.state;
        if (!requestToQueue) {
            return;
        }
        const { csid, transferToQueueModalRequestStop, modalClose, notificationAdd, } = this.props;
        this.props
            .transferToQueueModalRequest({
            requestToQueue,
            csid,
        })
            .then(() => {
            if (csid) {
                analytics.conversationTransferred({
                    conversationId: csid,
                    option: 'queue',
                });
            }
            transferToQueueModalRequestStop(csid);
            modalClose();
        })
            .catch((exception) => {
            console.warn(exception);
            transferToQueueModalRequestStop(csid);
            modalClose();
            const options = {
                title: 'Could not transfer the conversation',
                text: `An issue occurred while trying transfer conversation ${csid}.`,
                className: 'danger',
                icon: 'i-exclamation',
            };
            notificationAdd(options);
        });
    }
    onSelectQueue(queue) {
        this.setState({ selectedQueue: queue });
    }
    render() {
        const { ui, csid, modalClose } = this.props;
        const { isModalShown } = ui;
        const { selectedQueue } = this.state;
        return (_jsxs(Modal, Object.assign({ isOpen: isModalShown, onClose: modalClose }, { children: [_jsx(ModalHead, { title: `Transfer ${csid} to a different queue`, onClose: modalClose }), _jsx(ModalBody, { children: _jsx(Box, Object.assign({ width: "540px" }, { children: _jsx(QueueSelect, { selectedQueue: selectedQueue, onSelect: this.onSelectQueue }) })) }), _jsx(ModalFoot, { cancelOnClick: modalClose, confirmName: "Transfer", confirmProps: { disabled: !selectedQueue }, confirmOnClick: this.onRequest })] })));
    }
}
__decorate([
    boundMethod
], TransferToQueueModal.prototype, "onRequest", null);
__decorate([
    boundMethod
], TransferToQueueModal.prototype, "onSelectQueue", null);
export default connect(mapStateToProps, mapDispatchToProps)(TransferToQueueModal);
